var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-classification-toolbar',{attrs:{"title":"Mapeo de valores","classification":null,"classifications":[]},on:{"toggle-sidebar":_vm.toggleSidebar}})}
var staticRenderFns = []

export { render, staticRenderFns }